import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2734 12.2169L1.98047 21.5098L3.39468 22.924L12.6876 13.6311L21.9805 22.924L23.3947 21.5098L14.1018 12.2169L23.3947 2.92398L21.9805 1.50977L12.6876 10.8027L3.39468 1.50977L1.98047 2.92398L11.2734 12.2169Z",
		fill: "#395566"
	})
});
export default SvgLine;
